import { Injectable } from "@angular/core";
import { Router, CanActivate } from "@angular/router";
import { UserLoginService } from "../services/user-login.service";

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(public userService: UserLoginService, protected router: Router) {}

  canActivate(): Promise<boolean> {
    return new Promise((resolve) => {
      this.userService.canActivate(async (retVal: boolean) => {
        if (retVal) {
          resolve(true);
        } else {
          await this.router.navigate(["/home/login"]);
          resolve(false);
        }
      });
    });
  }
}
